import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Helmet} from 'react-helmet';
import {searchIfNeeded, fetchPopularAppsIfNeeded} from '../actions/search';
import AppBox from '../components/App-box';
import AppBoxWide from '../components/App-box-wide';
import classNames from 'classnames';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';
import SuggestApp from '../components/Suggest-an-app';
import {execBI} from '../services/bi-events-manager';
import ErrorMessage from '../components/Error-message';
import {openCategory} from '../actions/categories';
import {setAppMarketState} from '../services/wrapped-app-market-sdk';

const searchLoaded = (props, skipBI) => {
  const first = props.apps.length ? props.apps[0].appDefinitionId : '';
  execBI('SEARCH_RESULTS_LOADED', {num_results: props.apps.length, search_term: props.location.query.q, first_result_app_id: first, skipBI});
  setAppMarketState(props.apps.length ? `search,${props.location.query.q}` : '');
};

class Search extends React.Component {

  constructor(props) {
    super(props);
    this.handleSuggestApp = this.handleSuggestApp.bind(this);
  }

  static fetchData(dispatch, params, location) {
    return Promise.all([
      dispatch(searchIfNeeded(location.query.q)),
      dispatch(fetchPopularAppsIfNeeded()),
      dispatch(openCategory('search')),
    ]);
  }

  componentDidMount() {
    if (this.props.query === this.props.location.query.q) { // in case search was executed in server side
      searchLoaded(this.props, true);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.loading && !nextProps.loading) {
      searchLoaded(nextProps);
    }

    this.props.dispatch(searchIfNeeded(nextProps.location.query.q));
  }

  componentWillUnmount() {
    setAppMarketState('');
  }

  handleSuggestApp(origin, query, total) {
    execBI('WISH_LIST_CLICK');
    execBI('WISH_LIST_LOADED');
    this.setState({showSuggestApp: true, suggestAppData: {origin, query, total}});
  }

  render() {
    const state = this.state || {};
    const totalResults = this.props.apps.length;
    const query = this.props.location.query.q;

    return (
      <div className="page-search-results secondary-inner-page">

        <div className={classNames('inner-container', {'results-found': totalResults, 'no-results-found': !totalResults})}>

          <div className="search-header wishlist">

            {totalResults && !this.props.loading ?
              <div className="results-found-title section section-pad">
                <span className="typography_h1">
                  <FormattedHTMLMessage id="search.showingResultsForAppMarket20" values={{totalResults, query}}/>
                </span>
              </div> : null}

            {!totalResults && !this.props.loading ?
              <div className="results-not-found-title">
                {this.props.error ? <ErrorMessage className="error-message-centered"/> : ''}

                <div className="heading">
                  <div className="typography_h1">
                    <FormattedHTMLMessage id="search.noMatchesFoundAppMarket20" values={{query}}/>
                  </div>
                </div>

                {this.props.market !== 'standalone' ?
                  <div className="wishlist-add typography_t1">
                    <FormattedMessage id="wishlist.search.haveAGreatIdea"/>&nbsp;
                    <span onClick={() => this.handleSuggestApp('search_no_result', query, 0)} className="typography_t1_3 pointer">
                      <FormattedMessage id="wishlist.search.linkTitle"/>
                    </span>
                  </div> : null}
              </div> : null}

            {this.props.loading ? <div className="circle-loader"></div> : ''}
          </div>

          <div className="section section-pad">
            <div className="app-box-wide-list">
              {this.props.apps.map((app, i) =>
                <AppBoxWide app={app} key={app.slug} reviews={this.props.reviews} biPosition={i + 1}/>
              )}
            </div>
          </div>

          {!totalResults && !this.props.loading ?
            <div className="popular-apps">
              <div className="section section-pad">
                <div className="suggestion">
                  <span className="suggestion-text typography_t1_1"><FormattedMessage id="wishlist.search.seeMostPopularAlternative"/></span>
                </div>
              </div>

              <div className="app-box-grid section section-pad-left">
                {this.props.popular.map((app, i) =>
                  <AppBox app={app} key={app.slug} reviews={this.props.reviews} biPosition={i + 1}/>
                )}
              </div>
            </div> : null}

          {totalResults && this.props.market !== 'standalone' ?
            <div className="wishlist-container section section-pad">
              <div className="wishlist-icon-footer">
                <p className="wishlist-footer-text typography_t1">
                  <FormattedMessage id="wishlist.search.stillNotFound"/>&nbsp;
                  <span onClick={() => this.handleSuggestApp('search_results', query, totalResults)} className="typography_t1_3 pointer">
                    <FormattedMessage id="wishlist.search.linkTitle"/>
                  </span>
                </p>
              </div>
            </div> : null}

        </div>

        {state.showSuggestApp ? <SuggestApp data={state.suggestAppData} hide={() => this.setState({showSuggestApp: false})}/> : ''}

        <Helmet>
          <meta name="robots" content="noindex, nofollow"/>
        </Helmet>
      </div>
    );
  }
}

Search.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  apps: PropTypes.array.isRequired,
  popular: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  reviews: PropTypes.object.isRequired,
  error: PropTypes.bool,
  query: PropTypes.string,
  market: PropTypes.string
};


function mapStateToProps(state) {
  return {
    apps: state.search.apps,
    query: state.search.query,
    reviews: state.reviews.all,
    popular: state.search.popular,
    loading: state.search.isFetching,
    error: state.search.receivedAt === 0,
    market: state.mode.market
  };
}

export default connect(mapStateToProps)(Search);



// WEBPACK FOOTER //
// ./containers/Search.js